import { render } from "./PartDetails.vue?vue&type=template&id=878d3cf6&scoped=true"
import script from "./PartDetails.vue?vue&type=script&lang=js"
export * from "./PartDetails.vue?vue&type=script&lang=js"

import "./PartDetails.vue?vue&type=style&index=0&id=878d3cf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878d3cf6"]])

export default __exports__